import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextRenderer = /** @class */ (function (_super) {
    __extends(TextRenderer, _super);
    function TextRenderer() {
        var _this = _super.call(this) || this;
        // @todo
        Debug.throwPIR('playerglobals/text/TextRenderer', 'constructor', '');
        return _this;
    }
    Object.defineProperty(TextRenderer.prototype, "antiAliasType", {
        // static _antiAliasType: string;
        // static _maxLevel: number /*int*/;
        // static _displayMode: string;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'get antiAliasType', '');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'set antiAliasType', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRenderer.prototype, "maxLevel", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'get maxLevel', '');
            return 0;
        },
        set: function (value /*int*/) {
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'set maxLevel', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextRenderer.prototype, "displayMode", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'get displayMode', '');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/TextRenderer', 'set displayMode', '');
        },
        enumerable: false,
        configurable: true
    });
    TextRenderer.setAdvancedAntiAliasingTable = function (fontName, fontStyle, colorType, advancedAntiAliasingTable) {
        fontName = axCoerceString(fontName);
        fontStyle = axCoerceString(fontStyle);
        colorType = axCoerceString(colorType);
        // @todo
        Debug.throwPIR('playerglobals/text/TextRenderer', 'setAdvancedAntiAliasingTable', '');
    };
    // Called whenever the class is initialized.
    TextRenderer.classInitializer = null;
    // List of static symbols to link.
    TextRenderer.classSymbols = null; // [];
    // List of instance symbols to link.
    TextRenderer.instanceSymbols = null; // [];
    return TextRenderer;
}(ASObject));
export { TextRenderer };
